import { ComidasPanel } from "@/components/meal-plan/comidas-panel";

export function ComidasPage() {
  return <ComidasPanel />;
}
